/**
 * Schedule のタブ切替ストア（独立 namespace）
 *
 * NOTE: data-wp-class / data-wp-bind は PHP プロセッサで getter を評価できず
 * SSR で付けたクラス／属性を消されてしまうので、active 同期は data-wp-watch で。
 */
import { store, getContext, getElement } from '@wordpress/interactivity';

store('best-anniversary-blocks/schedule', {
	actions: {
		activate(event) {
			if (event && typeof event.preventDefault === 'function') {
				event.preventDefault();
			}
			const ctx = getContext();
			ctx.activeIndex = ctx.index;
		},
		handleKeydown(event) {
			const key = event.key;
			if (
				key !== 'ArrowLeft' &&
				key !== 'ArrowRight' &&
				key !== 'Home' &&
				key !== 'End'
			) {
				return;
			}
			event.preventDefault();

			const root = getElement().ref?.closest(
				'[data-wp-interactive="best-anniversary-blocks/schedule"]'
			);
			if (!root) {
				return;
			}

			const tabs = Array.from(
				root.querySelectorAll(
					'.wp-block-best-anniversary-blocks-schedule__nav-button[role="tab"]'
				)
			);
			if (tabs.length === 0) {
				return;
			}

			const idx = tabs.indexOf(getElement().ref);
			let next = idx;
			if (key === 'ArrowLeft') {
				next = (idx - 1 + tabs.length) % tabs.length;
			} else if (key === 'ArrowRight') {
				next = (idx + 1) % tabs.length;
			} else if (key === 'Home') {
				next = 0;
			} else if (key === 'End') {
				next = tabs.length - 1;
			}

			const ctx = getContext();
			ctx.activeIndex = next;
			tabs[next]?.focus();
		},
	},
	callbacks: {
		syncPanel() {
			const ctx = getContext();
			const isActive = ctx.activeIndex === ctx.index;
			const el = getElement().ref;
			if (!el) {
				return;
			}
			el.classList.toggle('is-active', isActive);
			el.setAttribute('aria-hidden', String(!isActive));
		},
		syncScheduleTab() {
			const ctx = getContext();
			const isActive = ctx.activeIndex === ctx.index;
			const el = getElement().ref;
			if (!el) {
				return;
			}
			el.classList.toggle('is-active', isActive);
			el.setAttribute('aria-selected', String(isActive));
			el.setAttribute('tabindex', isActive ? '0' : '-1');
		},
	},
});
